if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
			const paginationEl = slider.querySelector(".product-pagination .swiper-pagination");
			const nextBtnEl = slider.querySelector(".product-button-group .swiper-button-next");
			const prevBtnEl = slider.querySelector(".product-button-group .swiper-button-prev");

			const isInRecommendations = !!slider.closest('product-recommendations')
			const isMobile = window.innerWidth < 990

			const productSlider = new Swiper(slider, {
				pagination: {
					el: paginationEl,
					clickable: true,
				},
				navigation: {
					nextEl: dir === 'rtl' ? prevBtnEl : nextBtnEl,
					prevEl: dir === 'rtl' ? nextBtnEl : prevBtnEl,
				},
				allowTouchMove: !(isInRecommendations && isMobile),
			});

			if (productSlider.slides.length > 1 && slider.dataset.peekHint === 'true' && isMobile) {
				slider.classList.add('peek-hint');

				const stopPeek = () => slider.classList.remove('peek-hint');
				slider.addEventListener('touchstart', stopPeek, { once: true });
				productSlider.on('slideChange', stopPeek);
			}
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
